import { Editor } from "slate";

/**
 * slate-react's <Slate> assigns initialValue straight onto the editor without
 * normalizing, and a read-only viewer never dispatches operations. Without an
 * explicit pass here, plugin normalizeNode hooks (e.g. AutoInsertLists lifting a
 * list out of a paragraph) would never run and malformed authored content would
 * render as-is.
 */
export function normalizeInitialValue(editor: Editor, value: any[]): any[] {
  try {
    editor.children = value;
    editor.selection = null;
    Editor.normalize(editor, { force: true });
    return editor.children;
  } catch {
    editor.children = value;
    return value;
  }
}
